export default "<p>asset-assigments works!</p>\r\n";